/* MATIQ · interacciones propias — sin librerías externas */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  /* ── 0. Portada con diapositivas ─────────────────────────────── */
  /* Lo que hay encima de la portada (la cinta de anuncios) se mide una vez y
     se publica como variable: el CSS no tiene forma de saberlo solo, y sin ese
     número la portada mide una ventana entera y su cinta inferior queda
     siempre fuera de la pantalla. */
  function medirTope() {
    var hero = document.querySelector('.mq-hero');
    if (!hero) return;
    var tope = Math.max(0, Math.round(hero.getBoundingClientRect().top + (window.pageYOffset || 0)));
    document.documentElement.style.setProperty('--mq-tope', tope + 'px');
  }

  function initHero() {
    medirTope();
    /* En el teléfono, `resize` se dispara en cada scroll porque la barra de
       direcciones aparece y desaparece. Recalcular la portada en cada uno de
       esos avisos la hace saltar y traba el scroll: sólo se mide cuando
       cambia el ANCHO, que es cuando de verdad cambia la maqueta. */
    var anchoVentana = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === anchoVentana) return;
      anchoVentana = window.innerWidth;
      medirTope();
    });

    document.querySelectorAll('[data-mq-hero]:not([data-mq-ready])').forEach(function (hero) {
      hero.setAttribute('data-mq-ready', '1');
      var bgs = hero.querySelectorAll('.mq-hero__bg');
      var copies = hero.querySelectorAll('.mq-hero__copy');
      var dots = hero.querySelectorAll('.mq-hero__dot');
      if (copies.length < 2) return;

      var dur = parseInt(hero.getAttribute('data-interval'), 10) || 7000;
      hero.style.setProperty('--mq-dur', (dur / 1000) + 's');
      var i = 0, timer = null;

      function show(n) {
        i = (n + copies.length) % copies.length;
        [bgs, copies, dots].forEach(function (set) {
          set.forEach(function (el, k) { el.classList.toggle('on', k === i); });
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-selected', String(k === i)); });
        // reinicia la barra de progreso del punto activo
        var bar = dots[i] && dots[i].querySelector('i');
        if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; void bar.offsetWidth; bar.style.transition = ''; bar.style.width = ''; }
      }
      function play() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, dur); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-go'), 10)); play(); });
      });
      // Pasan siempre solas: solo se detienen si la pestaña queda oculta,
      // para no gastar batería en segundo plano.
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

      show(0); play();
    });
  }

  /* ── 1. Entradas al hacer scroll ─────────────────────────────── */
  function initReveals() {
    var items = document.querySelectorAll('.mq-rv:not(.in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    var alto = window.innerHeight || 800;
    items.forEach(function (el) {
      var group = el.closest('[data-mq-stagger]');
      if (group) {
        var sibs = Array.prototype.slice.call(group.querySelectorAll('.mq-rv'));
        el.style.transitionDelay = Math.min(Math.max(sibs.indexOf(el), 0), 5) * 80 + 'ms';
      }
      // Lo que ya está en pantalla al cargar se muestra de entrada: esperar al
      // observador deja la primera pantalla en blanco si el navegador está
      // ahorrando recursos (pestaña en segundo plano, conexión lenta).
      var r = el.getBoundingClientRect();
      if (r.top < alto && r.bottom > 0) { el.classList.add('in'); io.unobserve(el); return; }
      io.observe(el);
    });

    /* Red de seguridad. Las animaciones de entrada dejan el contenido en
       `opacity:0` hasta que el observador avisa; si el observador se atrasa o
       falla —pasa en celulares con el scroll por inercia—, la persona ve una
       pantalla en blanco y cree que la página se colgó. Por eso el observador
       es una MEJORA, no un requisito: además se revisa a los 2,5 s y en cada
       scroll, y lo que esté a la vista se muestra sí o sí. */
    function rescatar() {
      var alto2 = window.innerHeight || 800;
      document.querySelectorAll('.mq-rv:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < alto2 * 1.15 && r.bottom > -alto2 * 0.15) el.classList.add('in');
      });
    }
    setTimeout(rescatar, 2500);

    var pidiendo = false;
    window.addEventListener('scroll', function () {
      if (pidiendo) return;
      pidiendo = true;
      requestAnimationFrame(function () { pidiendo = false; rescatar(); });
    }, { passive: true });
  }

  /* ── 2. Escenas del día ──────────────────────────────────────── */
  function initScenes() {
    document.querySelectorAll('[data-mq-scenes]:not([data-mq-ready])').forEach(function (root) {
      root.setAttribute('data-mq-ready', '1');
      var data;
      try { data = JSON.parse(root.querySelector('[data-mq-scene-data]').textContent); }
      catch (err) { return; }

      var clock = root.querySelector('[data-mq-clock]');
      var tabs = root.querySelectorAll('.mq-tab');
      var played = false;

      function apply(key) {
        var s = data[key];
        if (!s) return;
        root.classList.remove('is-m', 'is-t', 'is-n');
        root.classList.add('is-' + key);
        root.querySelectorAll('.mq-layer').forEach(function (l) {
          l.classList.toggle('on', l.getAttribute('data-k') === key);
        });
        root.querySelectorAll('.mq-copy').forEach(function (c) {
          c.classList.toggle('on', c.getAttribute('data-copy') === key);
        });
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', String(t.getAttribute('data-tab') === key));
        });
        if (clock) clock.textContent = s.clock;
        root.querySelectorAll('.mq-dev').forEach(function (d) {
          var st = s.dev[d.getAttribute('data-dev')];
          if (!st) return;
          d.querySelector('[data-state]').textContent = st[0];
          d.classList.toggle('on', !!st[1]);
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { played = true; apply(t.getAttribute('data-tab')); });
      });
      apply('m');

      if (!reduce && 'IntersectionObserver' in window) {
        var demo = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting || played) return;
            played = true;
            setTimeout(function () { apply('t'); }, 1700);
            setTimeout(function () { apply('n'); }, 3600);
            setTimeout(function () { apply('m'); }, 5500);
            demo.disconnect();
          });
        }, { threshold: 0.35 });
        demo.observe(root);
      }
    });
  }

  /* ── 3. Parallax suave del fondo del hero ────────────────────── */
  var parallaxOn = false;
  function initParallax() {
    var layers = document.querySelectorAll('[data-mq-parallax]');
    if (!layers.length || reduce || parallaxOn) return;
    parallaxOn = true;
    layers.forEach(function (l) { l.style.willChange = 'transform'; });
    var ticking = false;
    function frame() {
      layers.forEach(function (l) {
        var r = l.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var amount = parseFloat(l.getAttribute('data-mq-parallax')) || 12;
        /* El scale(1.12) deja un 6 % de holgura por lado. Si el desplazamiento
           se pasa de esa holgura, la foto se despega del borde y aparece una
           franja negra abajo (se veía sobre todo en tablet, donde la portada
           es más baja y la holgura, menor). Por eso se recorta al máximo que
           la escala puede cubrir. */
        var holgura = r.height * 0.055;
        var y = -r.top * (amount / 100);
        if (y > holgura) y = holgura; else if (y < -holgura) y = -holgura;
        l.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }, { passive: true });
    frame();
  }

  /* ── 3b. Pasos del proceso: la lectura avanza sola ───────────────
     Se enciende un paso por vez, al ritmo al que se lee el de al lado, para
     que el ojo siga el orden. Arranca recién cuando la sección entra en
     pantalla y se detiene cuando sale: si empezara antes, el visitante
     llegaría con la secuencia a la mitad. Con prefers-reduced-motion se
     encienden todos de una y no hay animación. */
  function initPasos() {
    var grillas = document.querySelectorAll('[data-mq-pasos]');
    if (!grillas.length) return;
    grillas.forEach(function (g) {
      if (g.hasAttribute('data-mq-ready')) return;
      g.setAttribute('data-mq-ready', '1');
      var pasos = Array.prototype.slice.call(g.querySelectorAll('.mq-step'));
      if (!pasos.length) return;

      if (reduce) { pasos.forEach(function (p) { p.classList.add('is-paso'); }); return; }

      var ritmo = parseInt(g.getAttribute('data-mq-pasos'), 10) || 3200;
      var i = 0, timer = null;

      function avanzar() {
        pasos.forEach(function (p, k) { p.classList.toggle('is-paso', k === i); });
        i = (i + 1) % pasos.length;
      }
      function arrancar() {
        if (timer) return;
        avanzar();
        timer = setInterval(avanzar, ritmo);
      }
      function parar() {
        if (!timer) return;
        clearInterval(timer); timer = null;
      }

      if (!('IntersectionObserver' in window)) { arrancar(); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? arrancar() : parar(); });
      }, { threshold: 0.35 }).observe(g);
    });
  }

  /* ── 3c. Catálogo: los filtros se aplican solos ──────────────────
     Un formulario con botón "Aplicar" obliga a un clic extra que nadie
     espera en 2026. Al tocar una casilla o cambiar el orden se arma la URL
     con los parámetros marcados y se navega. Sin JS el <noscript> deja el
     botón de siempre, así que la página sigue funcionando. */
  function initFiltros() {
    var form = document.getElementById('mq-filtros');
    var sort = document.querySelector('[data-mq-sort]');
    if (!form && !sort) return;
    if (form && form.hasAttribute('data-mq-ready')) return;

    function aplicar() {
      var base = window.location.pathname;
      var p = new URLSearchParams();
      if (form) {
        form.querySelectorAll('input[type=checkbox]:checked').forEach(function (c) {
          p.append(c.name, c.value);
        });
        form.querySelectorAll('input[type=number]').forEach(function (n) {
          if (n.value !== '') p.set(n.name, n.value);
        });
      }
      if (sort && sort.value) p.set('sort_by', sort.value);
      window.location.href = p.toString() ? base + '?' + p.toString() : base;
    }

    /* En pantallas angostas la barra se muestra como desplegable: tiene que
       arrancar cerrada o empuja la grilla de productos fuera de la primera
       pantalla. Se deja abierta en el HTML para quien navegue sin JS.

       Lo que decide NO es el ancho de la ventana sino el del catálogo: el
       panel del carrito de Horizon empuja la página y la deja angosta sin que
       la ventana cambie, así que midiendo la ventana la barra se quedaba
       abierta y desplegada ocupando todo el ancho. */
    var caja = document.querySelector('.mq-side__wrap');
    var shop = document.querySelector('.mq-shop');
    if (caja && shop) {
      /* si la persona lo abre o lo cierra a mano, mandan sus dedos */
      caja.addEventListener('toggle', function () {
        if (caja._auto) { caja._auto = false; return; }
        caja._aMano = true;
      });
      /* Sólo importa el ANCHO. Abrir o cerrar el desplegable cambia el ALTO
         del catálogo, que vuelve a disparar al observador: sin este filtro se
         entra en un ida y vuelta que en el teléfono deja la página trabada.
         Y el trabajo se difiere a un frame, que es lo que pide la API para no
         escribir el layout dentro de la propia notificación. */
      var anchoPrevio = -1;
      var pendiente = false;
      var acomodar = function () {
        pendiente = false;
        var ancho = shop.clientWidth;
        if (ancho === anchoPrevio) return;
        anchoPrevio = ancho;
        if (caja._aMano) return;
        var quiere = ancho > 980;
        if (caja.open !== quiere) { caja._auto = true; caja.open = quiere; }
      };
      var pedirAcomodar = function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(acomodar);
      };
      acomodar();
      if (window.ResizeObserver) {
        new ResizeObserver(pedirAcomodar).observe(shop);
      } else {
        window.addEventListener('resize', pedirAcomodar);
      }
    }

    if (form) {
      form.setAttribute('data-mq-ready', '1');
      form.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') aplicar();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); aplicar(); });
      /* el precio se aplica al salir del campo o con Enter, no en cada tecla */
      form.querySelectorAll('input[type=number]').forEach(function (n) {
        n.addEventListener('change', aplicar);
        n.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); aplicar(); } });
      });
    }
    if (sort) sort.addEventListener('change', aplicar);
  }

  /* ── 3d. Carrito desde el catálogo ───────────────────────────────
     El cuadrado agrega una unidad y después se convierte en el contador de
     esa línea. Todo por fetch, y siempre con una sola fuente de verdad: el
     carrito. Después de cada cambio se relee `/cart.js`, se repintan los
     contadores y se le avisa al tema con SU evento —`shopify:cart:lines-update`,
     el que escuchan el globo del encabezado y el panel—, porque un evento
     inventado no lo escucha nadie y el número del carrito se quedaba viejo
     hasta recargar la página. */
  function initAgregar() {
    var formularios = document.querySelectorAll('[data-mq-add]');
    var cajas = document.querySelectorAll('[data-mq-qty]');
    if ((!formularios.length && !cajas.length) || !window.fetch) return;

    function avisarAlTema(total) {
      var ev = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { itemCount: total, source: 'mq-catalogo' }
      });
      ev.promise = Promise.resolve({
        cart: { totalQuantity: total },
        detail: { itemCount: total, source: 'mq-catalogo' }
      });
      document.dispatchEvent(ev);
      pintarGlobo(total);
    }

    /* Y además se pinta el globo a mano. El evento depende de que el
       componente del tema lo escuche y lo entienda; si en algún navegador eso
       falla, el número del encabezado se queda viejo y desde el teléfono
       parece que el producto no se hubiera agregado. Esto no depende de
       nadie. */
    function pintarGlobo(total) {
      document.querySelectorAll('.cart-bubble').forEach(function (g) {
        var n = g.querySelector('.cart-bubble__text-count');
        if (n) {
          n.textContent = total;
          n.classList.toggle('hidden', total < 1);
        }
        g.classList.toggle('visually-hidden', total < 1);
        var icono = g.closest ? g.closest('cart-icon') : null;
        if (icono) icono.classList.toggle('header-actions__cart-icon--has-cart', total > 0);
      });
      if (total > 0) {
        document.querySelectorAll('cart-icon').forEach(function (i) {
          i.classList.remove('mq-late');
          void i.offsetWidth;          /* reinicia la animación */
          i.classList.add('mq-late');
        });
      }
    }

    function pintar(caja, n) {
      var form = caja.previousElementSibling;
      if (n > 0) {
        caja.hidden = false;
        caja.querySelector('[data-n]').textContent = n;
        if (form) form.hidden = true;
      } else {
        caja.hidden = true;
        if (form) form.hidden = false;
      }
    }

    /* Relee el carrito, deja cada tarjeta contando lo mismo que él y
       actualiza el globo del encabezado. */
    function refrescar(tope) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var porVariante = {};
          (cart.items || []).forEach(function (i) { porVariante[i.variant_id] = i.quantity; });
          cajas.forEach(function (c) {
            c.classList.remove('is-load');
            pintar(c, porVariante[c.getAttribute('data-var')] || 0);
          });
          if (tope) {
            tope.classList.add('is-tope');
            tope.setAttribute('title', 'No hay más unidades disponibles');
            setTimeout(function () { tope.classList.remove('is-tope'); }, 1600);
          }
          avisarAlTema(cart.item_count || 0);
          /* Si la página además muestra el carrito (la página de carrito con
             sus recomendados debajo), hay que repintarlo: si no, se suma algo
             desde una tarjeta y la lista de arriba sigue mostrando lo viejo. */
          if (document.querySelector('[data-mq-cart]')) repintarCarrito();
          return cart;
        })
        .catch(function () {
          cajas.forEach(function (c) { c.classList.remove('is-load'); });
        });
    }

    /* Abre el panel del carrito, como cuando se agrega desde la ficha. En el
       teléfono el globo del encabezado es minúsculo y agregar algo se siente
       como que no pasó nada; el panel es la confirmación. Se abre SOLO al
       agregar con el cuadrado, nunca al tocar + o − en el contador: ahí uno
       está ajustando la cantidad y un panel que salta molesta. */
    function abrirPanel() {
      var sec = document.querySelector('[data-mq-shop]');
      if (sec && sec.getAttribute('data-panel') === 'no') return;
      var icono = document.querySelector('cart-icon');
      var boton = icono && icono.closest ? icono.closest('button') : null;
      if (!boton) return;
      /* El botón hace `toggle`: si el panel YA está abierto, volver a
         apretarlo lo cerraría justo después de agregar algo. El estado real
         lo dice el propio botón con `aria-expanded`. */
      if (boton.getAttribute('aria-expanded') === 'true') return;
      boton.click();
    }

    var enVuelo = Promise.resolve();

    function enviar(caja, n) {
      enVuelo = enVuelo.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: caja.getAttribute('data-var'), quantity: n })
        }).then(function (r) {
          /* 422 = se pidió más de lo que hay en stock. El cuerpo no trae el
             carrito, así que hay que releerlo o el contador desaparecería
             como si el producto se hubiera ido. */
          return refrescar(r.status === 422 ? caja : null);
        }).catch(function () { return refrescar(null); });
      });
      return enVuelo;
    }

    function cambiar(caja, n) {
      pintar(caja, n);                       // el clic responde al instante
      caja.classList.add('is-load');
      clearTimeout(caja._t);
      /* los clics seguidos se agrupan en un solo pedido con el valor final */
      caja._t = setTimeout(function () { enviar(caja, n); }, 450);
    }

    formularios.forEach(function (form) {
      if (form.hasAttribute('data-mq-ready')) return;
      form.setAttribute('data-mq-ready', '1');
      var caja = form.nextElementSibling;
      var btn = form.querySelector('.mq-add');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-load')) return;
        btn.classList.add('is-load');
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
        }).then(function (r) {
          btn.classList.remove('is-load');
          if (r.status === 422) return refrescar(caja);
          if (!r.ok) throw new Error('no');
          btn.classList.add('is-ok');
          setTimeout(function () { btn.classList.remove('is-ok'); }, 900);
          return refrescar(null).then(function () { abrirPanel(); });
        }).catch(function () {
          btn.classList.remove('is-load');
          form.submit();
        });
      });
    });

    cajas.forEach(function (caja) {
      if (caja.hasAttribute('data-mq-ready')) return;
      caja.setAttribute('data-mq-ready', '1');
      caja.querySelectorAll('[data-paso]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(caja.querySelector('[data-n]').textContent, 10) || 0;
          cambiar(caja, Math.max(0, n + parseInt(b.getAttribute('data-paso'), 10)));
        });
      });
    });

    /* ── Elegir el color (o la medida) sin salir de la tarjeta ──────
       Marcar una opción cambia tres cosas a la vez: qué variante manda el
       formulario, a qué variante mira el contador, y el precio que se
       muestra —la cortina de 4 m no vale lo mismo que la de 3 m—. Después
       se relee el carrito para que el cuadrado y el contador cuenten lo de
       ESA variante y no lo de la anterior. */
    document.querySelectorAll('[data-mq-ops]').forEach(function (ops) {
      if (ops.hasAttribute('data-mq-ready')) return;
      ops.setAttribute('data-mq-ready', '1');
      /* La tarjeta, no el padre inmediato: las opciones viven en el cuerpo y
         el formulario en la fila de botones, que es un hermano. Buscando desde
         el padre no se encontraba el campo y el carrito se llevaba siempre la
         variante por defecto aunque el precio de la tarjeta sí cambiara. */
      var tarjeta = ops.closest ? ops.closest('.mq-card') : ops.parentElement;
      if (!tarjeta) return;

      ops.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.mq-op') : null;
        if (!b || b.disabled || b.classList.contains('is-on')) return;

        ops.querySelectorAll('.mq-op').forEach(function (o) {
          o.classList.remove('is-on');
          o.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('is-on');
        b.setAttribute('aria-pressed', 'true');

        var id = b.getAttribute('data-var');
        var campo = tarjeta.querySelector('[data-mq-add] [name="id"]');
        if (campo) campo.value = id;
        var caja = tarjeta.querySelector('[data-mq-qty]');
        if (caja) caja.setAttribute('data-var', id);

        var precio = tarjeta.querySelector('[data-mq-precio]');
        var txt = b.getAttribute('data-precio');
        if (precio && txt) {
          var antes = b.getAttribute('data-antes');
          precio.innerHTML = antes ? txt + ' <s>' + antes + '</s>' : txt;
        }

        refrescar(null);
      });
    });

    /* al cargar, lo que ya esté en el carrito arranca mostrando su contador */
    refrescar(null);
  }


  /* ── 4 bis. Carrito ───────────────────────────────────────────
     Sumar, restar y quitar sin recargar. El pedido a `/cart/change.js`
     pide de paso el HTML ya renderizado de las secciones que muestran el
     carrito, así los importes los sigue formateando Liquid: no hay una
     segunda cuenta en JavaScript que pueda decir otra cosa.            */
  function seccionesDelCarrito() {
    var ids = [];
    document.querySelectorAll('[data-mq-cart],[data-mq-rel]').forEach(function (el) {
      var id = el.getAttribute('data-seccion');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  function aplicarSecciones(secciones) {
    if (!secciones) return;
    Object.keys(secciones).forEach(function (id) {
      var destino = document.querySelector('[data-seccion="' + id + '"]');
      if (!destino || typeof secciones[id] !== 'string') return;
      var tmp = document.createElement('div');
      tmp.innerHTML = secciones[id];
      var fuente = tmp.querySelector('[data-seccion="' + id + '"]');
      if (fuente) destino.innerHTML = fuente.innerHTML;
    });
  }

  /* Vuelve a pedirle a Shopify el HTML del carrito. Se usa cuando el cambio
     NO salió de esta sección (por ejemplo al sumar desde los recomendados). */
  function repintarCarrito() {
    var sec = document.querySelector('[data-mq-cart]');
    if (!sec || !window.fetch) return Promise.resolve();
    var id = sec.getAttribute('data-seccion');
    return fetch('/cart?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fuente = tmp.querySelector('[data-mq-cart]');
        if (fuente) sec.innerHTML = fuente.innerHTML;
      })
      .catch(function () {});
  }

  function initCarrito() {
    var sec = document.querySelector('[data-mq-cart]');
    if (!sec || !window.fetch || sec.hasAttribute('data-mq-ready')) return;
    sec.setAttribute('data-mq-ready', '1');

    function avisarAlTema(total) {
      var ev = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { itemCount: total, source: 'mq-carrito' }
      });
      ev.promise = Promise.resolve({
        cart: { totalQuantity: total },
        detail: { itemCount: total, source: 'mq-carrito' }
      });
      document.dispatchEvent(ev);
    }

    var enVuelo = Promise.resolve();

    function enviar(fila, cantidad) {
      var cuerpo = {
        id: fila.getAttribute('data-key'),
        quantity: cantidad,
        sections: seccionesDelCarrito().join(','),
        sections_url: '/cart'
      };
      enVuelo = enVuelo.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(cuerpo)
        })
          .then(function (r) { return r.json().then(function (j) { return { estado: r.status, cart: j }; }); })
          .then(function (res) {
            /* 422 = se pidió más de lo que hay en stock. Ese cuerpo no trae ni
               el carrito ni las secciones, así que se vuelve a leer todo. */
            if (res.estado === 422) {
              return repintarCarrito().then(function () {
                var vuelta = sec.querySelector('[data-key="' + cuerpo.id + '"] .mq-qty');
                if (vuelta) {
                  vuelta.classList.add('is-tope');
                  vuelta.setAttribute('title', 'No hay más unidades disponibles');
                  setTimeout(function () { vuelta.classList.remove('is-tope'); }, 1600);
                }
              });
            }
            aplicarSecciones(res.cart.sections);
            avisarAlTema(res.cart.item_count || 0);
          })
          .catch(function () { window.location.reload(); });
      });
      return enVuelo;
    }

    function cambiar(fila, cantidad) {
      if (cantidad <= 0) {
        fila.classList.add('is-fuera');
        clearTimeout(fila._t);
        enviar(fila, 0);
        return;
      }
      var n = fila.querySelector('[data-n]');
      if (n) n.textContent = cantidad;        // el clic responde al instante
      clearTimeout(fila._t);
      /* los clics seguidos se agrupan en un solo pedido con el valor final */
      fila._t = setTimeout(function () { enviar(fila, cantidad); }, 420);
    }

    /* Delegación: el interior de la sección se reemplaza entero en cada
       cambio, así que escuchar en los botones duraría un solo clic. */
    sec.addEventListener('click', function (e) {
      var paso = e.target.closest ? e.target.closest('[data-paso]') : null;
      if (paso && sec.contains(paso)) {
        var fila = paso.closest('[data-mq-linea]');
        if (!fila) return;
        var actual = parseInt(fila.querySelector('[data-n]').textContent, 10) || 0;
        cambiar(fila, actual + parseInt(paso.getAttribute('data-paso'), 10));
        return;
      }
      var quitar = e.target.closest ? e.target.closest('[data-mq-quitar]') : null;
      if (quitar) {
        var f = quitar.closest('[data-mq-linea]');
        if (f) cambiar(f, 0);
        return;
      }
      var cupon = e.target.closest ? e.target.closest('[data-mq-cupon-ok]') : null;
      if (cupon) aplicarCupon();
    });

    /* Shopify aplica los códigos por URL: `/discount/CODIGO` los guarda en la
       sesión y devuelve a donde se le diga. Es la única vía sin app. */
    function aplicarCupon() {
      var campo = sec.querySelector('[data-mq-cupon]');
      if (!campo) return;
      var codigo = (campo.value || '').trim();
      if (!codigo) { campo.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
    }

    sec.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.hasAttribute('data-mq-cupon')) {
        e.preventDefault();
        aplicarCupon();
      }
    });
  }

  /* ── 4. Planta del proyecto: ambientes que se encienden ──────── */
  function initPlan() {
    var plans = document.querySelectorAll('[data-mq-plan]');
    if (!plans.length || reduce) return;
    plans.forEach(function (plan) {
      if (plan.hasAttribute('data-mq-ready')) return;
      plan.setAttribute('data-mq-ready', '1');
      var rooms = Array.prototype.slice.call(plan.querySelectorAll('i'));
      if (!rooms.length) return;
      var i = 0, timer = null;
      function tick() {
        rooms.forEach(function (r) { r.classList.remove('on'); });
        for (var k = 0; k <= i % rooms.length; k++) rooms[k].classList.add('on');
        i++;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !timer) { timer = setInterval(tick, 900); }
            else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.1 }).observe(plan);
      } else { timer = setInterval(tick, 900); }
    });
  }

  /* ── 5. Acordeón: solo uno abierto por bloque ────────────────── */
  function initFaq() {
    document.querySelectorAll('[data-mq-faq]:not([data-mq-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-mq-ready', '1');
      var all = wrap.querySelectorAll('details');
      all.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          all.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function boot() {
    initHero();
    initReveals();
    initScenes();
    initParallax();
    initPasos();
    initFiltros();
    initAgregar();
    initCarrito();
    initPlan();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* el editor de Shopify recarga secciones sueltas */
  document.addEventListener('shopify:section:load', boot);
})();
